<section class="splash" aria-labelledby="splash-title">
  <header class="splash__header">
    <span class="splash__logo">
      <img src="assets/icons/eInvoiceViewer.svg" alt="" />
    </span>
    <div class="splash__heading">
      <span class="splash__app-name" i18n="@@einvoice.start-page.app-name">E-Invoice Viewer</span>
      <h1 id="splash-title" class="splash__title" i18n="@@einvoice.start-page.title">Open e-invoices with ease</h1>
    </div>
    <button type="button" class="splash__close"
      [attr.aria-label]="closeLabel"
      [attr.title]="closeLabel"
      (click)="startApp()">
      <mat-icon svgIcon="close" aria-hidden="true"></mat-icon>
    </button>
  </header>

  <p class="splash__intro" i18n="@@einvoice.start-page.subtitle">Read and automatically validate XRechnung and ZUGFeRD invoices.</p>

  <ul class="splash__benefits">
    <li><mat-icon svgIcon="check_circle" aria-hidden="true"></mat-icon><span i18n="@@einvoice.start-page.benefit.free">Free</span></li>
    <li><mat-icon svgIcon="person" aria-hidden="true"></mat-icon><span i18n="@@einvoice.start-page.benefit.no-sign-up">No sign-up required</span></li>
    <li><mat-icon svgIcon="verified_user" aria-hidden="true"></mat-icon><span i18n="@@einvoice.start-page.benefit.local">Processed in your browser</span></li>
  </ul>

  <button type="button" class="splash__primary" (click)="startApp()">
    <span i18n="@@einvoice.start-page.button.open">Open E-Invoice Viewer</span>
    <mat-icon svgIcon="arrow_forward" aria-hidden="true"></mat-icon>
  </button>

  <div class="splash__more">
    <button type="button" class="splash__more-toggle"
      aria-controls="splash-more-info"
      [attr.aria-expanded]="moreInfoExpanded"
      [class.splash__more-toggle--expanded]="moreInfoExpanded"
      (click)="toggleMoreInfo()">
      <span i18n="@@einvoice.start-page.more-info">More about the viewer</span>
      <mat-icon svgIcon="expand_more" aria-hidden="true"></mat-icon>
    </button>
  </div>
  <div id="splash-more-info" class="splash__more-info" [class.splash__more-info--expanded]="moreInfoExpanded">
    <div class="splash__more-info-clip">
      <div class="splash__more-info-box">
        <p i18n="@@einvoice.start-page.more-info.formats">Open XRechnung invoices as XML files or ZUGFeRD invoices as PDFs. The viewer displays the invoice content clearly and automatically validates the e-invoice.</p>
        <p i18n="@@einvoice.start-page.more-info.privacy">All processing takes place locally in your browser. Your invoices are neither uploaded nor stored.</p>
      </div>
    </div>
  </div>

  <mat-checkbox class="splash__do-not-show" [(ngModel)]="doNotShowChecked"
    i18n="@@einvoice.start-page.do-not-show.label">Don't show this again</mat-checkbox>

  <footer class="splash__footer">
    <span class="splash__provider">
      <span i18n="@@einvoice.start-page.footer.provided-by">Provided by</span>
      <a [href]="getLink('conesprit')" target="_blank" rel="noopener">conesprit</a>
    </span>
    <nav class="splash__legal">
      <a [href]="getLink('privacy')" target="_blank" rel="noopener" i18n="@@einvoice.start-page.privacy-policy">Privacy Policy</a>
      <span aria-hidden="true">·</span>
      <a [href]="getLink('imprint')" target="_blank" rel="noopener" i18n="@@einvoice.start-page.legal-notice">Legal Notice</a>
    </nav>
  </footer>
</section>
